import React, { useEffect, useState } from 'react'
import { getApptilesNested } from '../shared-api/api'
import { useRequest } from 'ahooks'
import {
  getRefreshToken,
  getTiles,
  setStatusTile,
  setTilesOnLocal,
} from '../shared-constants/localstorage'
import { tileStatus } from '../shared-constants/tileStatus'
import { sharedPathes } from '../shared-routing/pathe'

const useAppTilesNested = () => {
  const [tiles, setTiles] = useState<any>(JSON.parse(getTiles()))
  const [floatingBarTiles, setFloatingBarTiles] = useState<any[]>([])

  const { run: fetchAppTiles, loading: appTilesLoading } = useRequest(
    getApptilesNested,
    {
      manual: true,
      debounceWait: 1000,
      debounceLeading: true,
      onSuccess(data: any) {
        const sortedData = data.sort((a, b) => a?.order - b?.order)
        const a: any = []
        const aIcon: any = []
        tiles?.forEach((element) => {
          const index = element.icon.indexOf('?')
          aIcon.push({ icon: element.icon.substr(0, index) })
          a.push({
            ...element,
            icon: null,
            shortCut: null,
          })
        })

        const b: any = []
        const bIcon: any = []
        sortedData?.forEach((element) => {
          const index = element.icon.indexOf('?')
          bIcon.push({ icon: element.icon.substr(0, index) })
          b.push({
            ...element,
            icon: null,
            shortCut: null,
          })
        })

        const floatingBar: any[] = []
        sortedData?.forEach((element) => {
          if (element?.shortCut) {
            floatingBar.push({
              ...element,
            })
          }
        })
        setFloatingBarTiles(floatingBar?.sort((a, b) => a?.order - b?.order))

        if (
          JSON.stringify(a) !== JSON.stringify(b) ||
          JSON.stringify(aIcon) !== JSON.stringify(bIcon)
        ) {
          setTiles(data.sort((a, b) => a?.order - b?.order))
          setTilesOnLocal(data.sort((a, b) => a?.order - b?.order))
        }

        setStatusTile(
          data
            .filter((d) => d.status == tileStatus.USER_LEVEL_ONE_FEATURE)
            .map((d) => d.url.replace(import.meta.env.VITE_MAIN_WEB_URL, '')),
        )
      },
      onError(error: any) {},
    },
  )

  useEffect(() => {
    if (
      !window.location.href.includes(sharedPathes.CINEMA) &&
      getRefreshToken()
    ) {
      fetchAppTiles()
    }
  }, [])

  return { tiles, appTilesLoading, floatingBarTiles }
}

export default useAppTilesNested
